import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e27cf1e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "post d-flex flex-column-fluid",
  id: "kt_post",
  ref: "root"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-xxl"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body py-20" }
const _hoisted_5 = { class: "mw-lg-950px mx-auto w-100" }
const _hoisted_6 = { class: "d-flex justify-content-between flex-column flex-sm-row mb-19" }
const _hoisted_7 = { class: "fw-boldest text-gray-800 fs-2qx pe-5 pb-7" }
const _hoisted_8 = { class: "border-bottom pb-12" }
const _hoisted_9 = { class: "d-flex justify-content-between flex-column flex-md-row" }
const _hoisted_10 = { class: "flex-grow-1 pt-8 mb-13" }
const _hoisted_11 = { class: "table-responsive border-bottom mb-14" }
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = { class: "border-bottom fs-6 fw-bolder text-muted text-uppercase" }
const _hoisted_14 = { class: "min-w-175px pb-9" }
const _hoisted_15 = { class: "min-w-70px pb-9 text-end" }
const _hoisted_16 = { class: "min-w-100px pe-lg-6 pb-9 text-end" }
const _hoisted_17 = { class: "d-flex align-items-center pt-11" }
const _hoisted_18 = { class: "pt-11" }
const _hoisted_19 = { class: "pt-11 fs-5 pe-lg-6 text-dark fw-boldest" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column mw-md-300px w-100\" data-v-e27cf1e8><div class=\"fw-bold fs-5 mb-3 text-dark00\" data-v-e27cf1e8> BANK TRANSFER </div><div class=\"d-flex flex-stack text-gray-800 mb-3 fs-6\" data-v-e27cf1e8><div class=\"fw-bold pe-5\" data-v-e27cf1e8>Account Name:</div><div class=\"text-end fw-norma\" data-v-e27cf1e8>Barclays UK</div></div><div class=\"d-flex flex-stack text-gray-800 mb-3 fs-6\" data-v-e27cf1e8><div class=\"fw-bold pe-5\" data-v-e27cf1e8>Account Number:</div><div class=\"text-end fw-norma\" data-v-e27cf1e8>1234567890934</div></div><div class=\"d-flex flex-stack text-gray-800 fs-6\" data-v-e27cf1e8><div class=\"fw-bold pe-5\" data-v-e27cf1e8>Code:</div><div class=\"text-end fw-norma\" data-v-e27cf1e8>BARC0032UK</div></div></div>", 1)
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-end d-none d-md-block mh-450px mx-9" }, null, -1))
const _hoisted_22 = { class: "text-end pt-10" }
const _hoisted_23 = { class: "fs-3 fw-bolder text-muted mb-3" }
const _hoisted_24 = { class: "fs-xl-2x fs-2 fw-boldest" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-bold" }, "Taxes included", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom w-100 my-7 my-lg-16" }, null, -1))
const _hoisted_27 = { class: "text-gray-600 fs-6 fw-bold mb-3" }
const _hoisted_28 = { class: "fs-6 fw-bold mb-8" }
const _hoisted_29 = { class: "text-gray-600 fs-6 fw-bold mb-3" }
const _hoisted_30 = { class: "fs-6 text-gray-800 fw-bold mb-8" }
const _hoisted_31 = { class: "text-gray-600 fs-6 fw-bold mb-3" }
const _hoisted_32 = { class: "fs-6 text-gray-800 fw-bold" }
const _hoisted_33 = {
  key: 0,
  class: "d-flex flex-stack flex-wrap mt-lg-20 pt-13"
}
const _hoisted_34 = { class: "my-1 me-5" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger my-1 me-12"
}, " Delete Invoice ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.invoice.invoice && _ctx.invoice.products)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t("INVOICE")), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("table", _hoisted_12, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_13, [
                              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("itemName")), 1),
                              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("quantity")), 1),
                              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("amount")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.products, (product) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "fw-bolder text-gray-700 fs-5 text-end",
                                key: product.id
                              }, [
                                _createElementVNode("td", _hoisted_17, [
                                  _createElementVNode("div", null, _toDisplayString(product.name), 1)
                                ]),
                                _createElementVNode("td", _hoisted_18, _toDisplayString(product.quantity), 1),
                                _createElementVNode("td", _hoisted_19, _toDisplayString(product.quantity * product.price +
                              " " +
                              _ctx.$store.state.currency), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _hoisted_20
                    ]),
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("TOTAL_AMOUNT")), 1),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.invoice.invoice.total_price + " " + _ctx.$store.state.currency), 1),
                      _hoisted_25,
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("INVOICE_TO")) + ". ", 1),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.invoice.invoice.customer_name), 1),
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("INVOICE_NO")) + ". ", 1),
                      _createElementVNode("div", _hoisted_30, " #" + _toDisplayString(_ctx.invoice.invoice.rand_number), 1),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("date")), 1),
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.invoice.invoice.release_date), 1)
                    ])
                  ])
                ]),
                (!_ctx.printing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createPDF && _ctx.createPDF(...args)), ["prevent"])),
                          class: "btn btn-light-primary my-1"
                        }, " Download ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ], 512))
    : _createCommentVNode("", true)
}